<script setup lang="ts">
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogClose, DialogTrigger } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import Sheet from '../ui/sheet/Sheet.vue';
import SheetTrigger from '../ui/sheet/SheetTrigger.vue';
import SheetContent from '../ui/sheet/SheetContent.vue';
import SheetHeader from '../ui/sheet/SheetHeader.vue';
import SheetFooter from '../ui/sheet/SheetFooter.vue';
import SheetClose from '../ui/sheet/SheetClose.vue';

const emit = defineEmits<{
    apply: []
}>()

const isOpen = ref(false)

function handleApply() {
    emit('apply')
    isOpen.value = false
}
</script>

<template>
    <Sheet v-model:open="isOpen" class="block md:hidden">
        <SheetTrigger as-child>
            <slot name="trigger" />
        </SheetTrigger>
        <SheetContent class="bg-white py-0 w-full px-2">
            <SheetHeader class="px-4 py-5">
                <p class="text-center uppercase text-[13px] tracking-widest">{{ $t('Filter') }}</p>
            </SheetHeader>
            <div class="overflow-y-auto max-h-[calc(100vh-140px)]">
                <slot />
            </div>
            <SheetFooter>
                <div class="px-5 py-5 w-full">
                    <Button variant="primary" size="lg" class="w-full" @click="handleApply">{{$t('Show')}}</Button>
                </div>
            </SheetFooter>
        </SheetContent>
    </Sheet>
</template>

<style scoped lang="scss">

</style>